import { toAverageOrNull, toNumberOrNull } from './metricsHistory';

export const NO_DATA = '—';

const METRIC_THRESHOLD_UP = 1.2;
const METRIC_THRESHOLD_UP_DOUBLE = 1.5;
const METRIC_THRESHOLD_DOWN = 0.85;
const METRIC_THRESHOLD_DOWN_DOUBLE = 0.6;

/**
 * Ratios from GET /companies are strings, or null when there's no data (ETFs
 * have no forward PE or EV/EBITDA). "0" is a real value, never "no data".
 */
export const formatRatio = (value) => {
  const number = toNumberOrNull(value);
  return number === null ? NO_DATA : number.toFixed(2);
};

export const formatRatioPercent = (value) => {
  const number = toNumberOrNull(value);
  return number === null ? NO_DATA : `${(number * 100).toFixed(2)}%`;
};

/**
 * How far a multiple sits from its average: 'doubleUp', 'up', 'down',
 * 'doubleDown', or null when there is nothing to show. Without both a positive
 * value and an average there is no comparison, never a comparison against 0.
 */
export const compareToAverage = (value, average) => {
  const number = toNumberOrNull(value);
  const metric = toAverageOrNull(average);
  if (number === null || number <= 0 || metric === null) {
    return null;
  }
  if (number > metric * METRIC_THRESHOLD_UP_DOUBLE) return 'doubleUp';
  if (number > metric * METRIC_THRESHOLD_UP) return 'up';
  if (number < metric * METRIC_THRESHOLD_DOWN_DOUBLE) return 'doubleDown';
  if (number < metric * METRIC_THRESHOLD_DOWN) return 'down';
  return null;
};

/**
 * DataGrid comparator for ratio columns: sorts numerically (the API sends
 * strings) and keeps missing values last in both directions.
 */
export const getRatioSortComparator = (sortDirection) => (v1, v2) => {
  const n1 = toNumberOrNull(v1);
  const n2 = toNumberOrNull(v2);
  if (n1 === null || n2 === null) {
    return (n1 === null) - (n2 === null);
  }
  return sortDirection === 'desc' ? n2 - n1 : n1 - n2;
};
